import { Download, File } from 'react-feather';
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import { useParams } from 'react-router-dom';

import { usePdfDownload, usePdfTemplates } from '../../../hooks/Download/usePdfDownload';
import { useRegion } from '../../../hooks/useRegion';

export const PdfOutputButton = () => {
  const { jianId } = useParams();
  const templates = usePdfTemplates();
  const downloadPdf = usePdfDownload(jianId ?? '');
  const region = useRegion();

  if (!jianId) {
    return null;
  }

  return (
    <Popover className="relative inline-block">
      <PopoverButton className="bg-white hover:bg-white/70 text-darkblue_100 rounded flex items-center gap-x-2 px-2 py-1">
        {region === 'Fujisawa' && (
          <>
            <Download size={24} />
            <div className="font-bold">PDF出力</div>
          </>
        )}
        {region === 'Default' && (
          <>
            <File size={22} />
            <div className="font-bold">帳票連携</div>
          </>
        )}
      </PopoverButton>
      {templates.length > 0 && (
        <PopoverPanel className="absolute right-0 mt-1 w-60 flex flex-col items-start gap-2 border-2 border-darkblue_100 bg-white rounded p-2">
          <ul className="space-y-1">
            {templates.map((template) => (
              <li key={template.templateId}>
                <button
                  key={template.templateId}
                  className="text-darkblue_100 hover:text-darkblue_70 hover:underline"
                  onClick={() => {
                    downloadPdf(template.templateId);
                  }}
                >
                  {template.templateName}
                </button>
              </li>
            ))}
          </ul>
        </PopoverPanel>
      )}
    </Popover>
  );
};
